import React, { useState } from 'react';
import ChevronLeft from '@mui/icons-material/ChevronLeft';
import * as S from './CollapsibleLeftPane.styled';

type CollapsibleLeftPaneProps = {
  isWeb?: boolean,
  title: string,
  /** Hide the web pane (and collapse chrome) at this max-width. */
  hideBelow: string,
  /** Web: tuck the pane to 0 width with no rail (ActivityLogs report-logs focus). */
  fullyHidden?: boolean,
  /** Web: open width +50% (ActivityLogs when the table is not showing). */
  expandWidth?: boolean,
  overlay?: React.ReactNode,
  children: React.ReactNode,
};

const CollapsibleLeftPane = ({
  isWeb,
  title,
  hideBelow,
  fullyHidden,
  expandWidth,
  overlay,
  children,
}: CollapsibleLeftPaneProps) => {
  const [isLeftPanelOpen, setIsLeftPanelOpen] = useState(true);
  const isPaneOpen = !isWeb || (isLeftPanelOpen && !fullyHidden);
  const titleLower = title.toLowerCase();

  return (
    <S.Shell
      isWeb={isWeb}
      $open={isPaneOpen}
      $expandWidth={Boolean(isWeb && expandWidth)}
      $fullyHidden={Boolean(isWeb && fullyHidden)}
      $hideBelow={hideBelow}
      {...(isWeb ? { 'data-page-enter-static': true } : {})}
    >
      {isWeb && !fullyHidden && (
        <S.PanelToggleRow $collapsed={!isLeftPanelOpen} $hideBelow={hideBelow}>
          <S.PanelTitle $hidden={!isLeftPanelOpen}>{title}</S.PanelTitle>
          <S.PanelToggle
            type="button"
            $expanded={isLeftPanelOpen}
            aria-expanded={isLeftPanelOpen}
            aria-label={isLeftPanelOpen
              ? `Collapse ${titleLower} panel`
              : `Open ${titleLower} panel`}
            title={isLeftPanelOpen
              ? `Collapse ${titleLower} panel`
              : `Open ${titleLower} panel`}
            onClick={() => setIsLeftPanelOpen((open) => !open)}
          >
            <ChevronLeft fontSize="small" />
          </S.PanelToggle>
        </S.PanelToggleRow>
      )}
      {overlay}
      <S.PaneBody
        aria-hidden={isPaneOpen === false}
        $open={isPaneOpen}
      >
        {children}
      </S.PaneBody>
    </S.Shell>
  );
};

export default CollapsibleLeftPane;
